<template>
  <ul class="badge-list">
    <li v-for="(badge, index) in badgeList" :key="index" class="right-top-area">
      <component
        :is="badgeComponent"
        :key="`${index}__${badge}__${type}`"
        :badge="badge"
      />
    </li>
  </ul>
</template>
<script setup>
  // v-common-tag-list 대응 컴포넌트
  import { computed, defineProps } from 'vue'
  import BrandTag from '@/components/tags/BrandTag.vue'
  import BottomLabel from '@/components/tags/BottomLabel.vue'

  const props = defineProps({
    badgeList: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String, // 'brand' |
      default: '',
    },
  })

  const badgeComponent = computed(() => {
    return props.type === 'brand' ? BrandTag : BottomLabel
  })
</script>
